(function($, once) {
  'use strict';
  var $body = null;
  var couponsInitialized = false;

  Drupal.behaviors.sello = {
    attach: function(context, settings) {
      $body = $('body');
      Drupal.behaviors.sello.initLanguageSwitcher();
      Drupal.behaviors.sello.initSearch();
      Drupal.behaviors.sello.initImageCarousel();
      Drupal.behaviors.sello.initViews();
      Drupal.behaviors.sello.initStore();
      Drupal.behaviors.sello.initCampaign();
      Drupal.behaviors.sello.initCoupons();
      Drupal.behaviors.sello.initOffersList();
      Drupal.behaviors.sello.initBasicPage();
      Drupal.behaviors.sello.applyCampaignColor();
      Drupal.behaviors.sello.initModal();

      $('.print-page').click(function() {
        window.print();
        return false;
      });

      $(window).trigger('resize');
    },

    initCoupons: function() {
      if (couponsInitialized) {
        return;
      }

      var $wrapper = $('.block-views-blockcoupons-front-page-coupons .view-content');
      if ($wrapper.length > 0) {
        var $items = $wrapper.find('.views-row');
        window.addEventListener('resize', () => {
          $wrapper.css('justify-content', '');
          var itemsWidth = 0;
          var maxWidth = $wrapper.width() - 50;
          $items.each(function() {
            itemsWidth += $(this).outerWidth();
          });
          if(itemsWidth > maxWidth) {
            $wrapper.removeClass('align-center');
          } else {
            $wrapper.addClass('align-center');
          }
        });
      }

      couponsInitialized = true;
    },

    initSearch: function() {
      $('.block-header-search-block').each(function() {
        var $block = $(this);
        var $searchWrapper = $block.find('.search-wrapper');

        $(window).on('resize.sello', function() {
          clearTimeout($.data(this, 'resizeTimer'));
          $.data(this, 'resizeTimer', setTimeout(function() {
            Drupal.behaviors.sello.initMobileSearch($block);
          }, 50));
        });
        Drupal.behaviors.sello.initMobileSearch($block, $searchWrapper);


        $searchWrapper.addClass('closed');
        $searchWrapper.find('input.icon').on("focus", function(event) {
          $searchWrapper.removeClass('closed').addClass('open');
          document.addEventListener('click', closeSearchField);
          event.stopPropagation();
        });

        function closeSearchField () {
          $searchWrapper.removeClass("open").addClass("closed");
          document.addEventListener('click', closeSearchField);         
        };
      });
    },

    initMobileSearch: function($block, $searchWrapper) {
      var counter = 0;
      var checkExist = setInterval(function() {
        var $mainMenu = $('#superfish-main-menu-fi-accordion');
        if($mainMenu.length > 0 && $mainMenu.find('INPUT.icon').length == 0) {
//          $(window).off('resize.sello');
          clearInterval(checkExist);
          /*
          var $mobileSearchWrapper = $block.find('INPUT.icon');
          if($mobileSearchWrapper.length > 0) {
            var $clone = $mobileSearchWrapper.clone(true, true);
            $clone.appendTo($mainMenu).wrap('<li class="search"></li>');
            $clone.show();
            $clone.on("keydown", function(e) {
              $searchWrapper.find('input.icon').val($clone.val());
            })
            //AddSearchAsync.i();
          }
          */
        } else if(counter++ > 20) {
          clearInterval(checkExist);
        }
      }, 100);
    },

    initLanguageSwitcher: function() {
      var $block = $('.block-language-switcher-block');
      var $toggle = $block.find('.toggle');
      $(once('language-switcher', $toggle)).click(function() {
        $block.find('.languages').slideToggle(150, function() {
          var visible = $(this).is(':visible');
          $toggle.removeClass('open closed').addClass(visible ? 'open' : 'closed');
        });
      });
    },

    initImageCarousel: function() {
      if($body.hasClass('page-node-type-front-page')) {
        var $owl = $('.owl-carousel');
        $owl.owlCarousel({
          nestedItemSelector: 'paragraph--type--image-carousel',
          items: 1,
          loop: true,
          autoplay: true,
          autoplayTimeout: 10000
        });

        // Clicking dot stops carousel
        $owl.find('.owl-dot').click(function() {
          $owl.trigger('stop.owl.autoplay'); // not working?
          var owl = $owl.data('owl.carousel');
          owl.settings.autoplay = false;
          owl.options.autoplay = false;
          $owl.trigger('refresh.owl.carousel');
        });
      }
    },

    initViews: function() {
      $('.view.onchange-exposed-filter').each(function(){
        var $view = $(this);
        $view.find('form.views-exposed-form').each(function() {
          var $form = $(this);
          var $inputs = $form.find('input.form-radio');
          var $mobile = $form.find('select');

          var classes = [];
          if(typeof Drupal.behaviors.sello.initViews.classes != 'undefined') {
            classes = Drupal.behaviors.sello.initViews.classes;
          } else {
            var classes2 = $view.get(0).className.split(' ');
            for(var i = 0; i < classes2.length; i++) {
              if(classes2[i].match(/^show-category-/)) {
                classes.push(classes2[i].substring(5));
              }
            }
            Drupal.behaviors.sello.initViews.classes = classes;
          }
          for(var i = 0; i < classes.length; i++) {
            $form.find('.'+classes[i]).show();
          }

          $inputs.filter(':checked').each(function() {
            var val = $(this).val();
            $mobile.find('option').removeAttr('selected').filter('option[value="'+val+'"]').attr('selected', 'selected');
          });

          $inputs.click(function() {
            $form.find('input.form-submit').trigger('click');
          });

          $mobile.change(function() {
            var val = $(this).val();
            var $el = $inputs.filter('input.form-radio[value="'+val+'"]');
            if($el.length > 0) {
              $el.prop('checked', true);
              $form.find('input.form-submit').trigger('click');
            }
          });
        });
      });
    },

    initStore: function() {
      var storePage = $body.hasClass('page-node-type-store');
      var restaurantPage = $body.hasClass('page-node-type-restaurant');
      var intranetPage = $body.hasClass('intranet');
      var lunchListingPage = $body.hasClass('page-node-type-lunch');

      if(storePage || restaurantPage || lunchListingPage) {
        // Lunch menus
        $('.block-lunch-menu-block, .block-this-week-lunch-menu-block').each(function() {
          var $block = $(this);
          var $dates = $block.find('.tabs-wrapper .date-selector');
          var $mobile = $block.find('select.tabs-wrapper-mobile');
          var $containers = $block.find('.menu-wrapper .date-container');

          $dates.click(function() {
            var key = $(this).data('link');
            var $container = $containers.filter('.'+key);
            $dates.not(this).removeClass('active');
            $(this).addClass('active');
            $containers.not($container).addClass('hidden');
            $container.removeClass('hidden');
            $mobile.find('option').removeAttr('selected').filter('option[value="'+key+'"]').attr('selected', 'selected');
          });

          $mobile.change(function() {
            var val = $(this).val();
            var $el = $dates.filter('.'+val);
            if($el.length > 0) {
              $el.trigger('click');
            }
          });

          if(lunchListingPage) {
            $containers.find('.menu-container').each(function() {
              var $container = $(this);
              var $lunch_wrapper = $container.find('.lunch-wrapper');
              var $toggle = $container.find('.menu-toggler');
              $lunch_wrapper.click(function() {
                $container.find('.hidden-rows').slideToggle(150, function() {
                  var visible = $(this).is(':visible');
                  var dataKey = visible ? 'hide' : 'show';
                  $toggle.removeClass('open closed').addClass(visible ? 'open' : 'closed');
                  $toggle.find('span').text($toggle.data(dataKey));
                });
              });
            });
          }
        });
      }
    },

    initCampaign: function() {
      if($body.hasClass('page-node-type-campaign')) {
        $(once('campaign-form', 'article.node--type-campaign.node--view-mode-full .form-wrapper')).each(function() {
          var $wrapper = $(this);
          var $toggle = $wrapper.find('.form-toggle');
          $toggle.click(function() {
            $wrapper.find('.form-content').slideToggle(150, function() {
              var visible = $(this).is(':visible');
              var dataKey = visible ? 'hide' : 'show';
              var wrapperClass = visible ? 'open' : 'closed';
              $wrapper.removeClass('open closed').addClass(wrapperClass);
              $toggle.find('span').text($toggle.data(dataKey));
            });
          });
        });
      }
    },

    initOffersList: function(){
      $('.block-views-blockoffers-front-page-offers, .block-views-blockoffers-store-offers, .block-views-blockoffers-all-offers, .block-views-blockoffers-campaign-offers').each(function(){
        var elem = $(this),
            ctaButtons = elem.find('.offer-cta'),
            popups = elem.find('.views-field-nothing-1'),
            closeButtons = elem.find('.offer-description-close');

        closeButtons.on('click', {'popups': popups}, function(){
          popups.css('display', 'none');
        });

        ctaButtons.each(function(){
          var button = $(this);
          button.on('click', function(viewContent, popup){
            popups = $('.views-field-nothing-1');
            popups.css('display', 'none');
            var button = $(this),
              row = button.parent().parent().parent(),
              viewContent = row.parent(),
              viewOffset = viewContent.offset(),
              rowOffset = row.offset();

            popup = row.find('.views-field-nothing-1');
            popup.css("top", (rowOffset.top - viewOffset.top - 40) + "px");
            popup.css('display', 'block');

          });

        });

      });
    },

    applyCampaignColor: function(){
      if($("BODY").hasClass('active-campaign') && ($("BODY").attr("data-bgcolor") != "" && $("BODY").attr("data-bgcolor") != undefined) ) {
        $(".navigation-container, .block-image-carousel-block").css('background-color', $("BODY").attr("data-bgcolor"));
        if ($("BODY").hasClass('page-node-type-campaign-sub-page') || $("BODY").hasClass('page-node-type-campaign-upcoming-page')) {
          $("DIV.footer-wrapper").css('background-color', $("BODY").attr("data-bgcolor"));
        }
      }


    },

    updateJuicer: function() {
      $('.juicer-feed .juicer-button').text(document.documentElement.lang == 'fi' ? 'Lataa lisää' : 'Show more');
    },

    initBasicPage: function() {
      if (!$.trim($('.page-node-type-page .layout-content-bottom').html()).length) {
        $('.layout-content-wrapper').addClass('full-radius');
      };
    },
    

    initModal: function() {
      const modals = document.querySelectorAll('.node--view-mode-modal');
      modals.forEach((modal) => {
        const title = modal.querySelector('.modal-title');
        const dialog = modal.querySelector('dialog');
        const closeButton = modal.querySelector('button.close');

        title.addEventListener("click", () => {
          dialog.showModal();
        });

        closeButton.addEventListener("click", () => {
          dialog.close();
        });
      });
    }
  };

}(jQuery, once));
